module.exports = "https://static.wagwalking.com/_next/static/images/pet-2-5301a0f7186ef050ca57a2e06627817e.png";